/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVINCheckerActivity
 */
export interface UpdateVINCheckerActivity {
    /**
     * 
     * @type {string}
     * @memberof UpdateVINCheckerActivity
     */
    vinCheckerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVINCheckerActivity
     */
    value?: boolean;
}

export function UpdateVINCheckerActivityFromJSON(json: any): UpdateVINCheckerActivity {
    return UpdateVINCheckerActivityFromJSONTyped(json, false);
}

export function UpdateVINCheckerActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVINCheckerActivity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vinCheckerId': !exists(json, 'vinCheckerId') ? undefined : json['vinCheckerId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function UpdateVINCheckerActivityToJSON(value?: UpdateVINCheckerActivity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vinCheckerId': value.vinCheckerId,
        'value': value.value,
    };
}


